import { render } from "./BGFLogo.vue?vue&type=template&id=bd0208b0"
import script from "./BGFLogo.vue?vue&type=script&lang=js"
export * from "./BGFLogo.vue?vue&type=script&lang=js"

import "./BGFLogo.vue?vue&type=style&index=0&id=bd0208b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__